import React, { PropsWithChildren } from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"

export type PageHeaderProps = {
  isMainPage?: boolean
  className?: string
  dataCy?: string
}

/*
 * @deprecated This component will be replaced by Header component
 */
const PHeader = (props: PropsWithChildren<PageHeaderProps>) => {
  const { className, isMainPage = false, children, dataCy } = props
  return (
    <Root className={className} $isMainPage={isMainPage} data-cy={dataCy}>
      {children}
    </Root>
  )
}

export const PageHeader = styled(PHeader)``

const Root = styled.div<{ $isMainPage?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.lx};
  width: 100%;

  ${theme.mui.breakpoints.up("md")} {
    flex-direction: row;
  }

  ${(p) =>
    p.$isMainPage &&
    css`
      box-shadow: 0 0 3px ${theme.color.grey1};
      padding-bottom: ${theme.spacing.xxl};
    `}
`
